import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-stats-grid mb-8" }

import { useRouter } from 'vue-router'
import { StatsCard } from '@/components'
import type { DashboardStats } from '@/types'

interface Props {
  stats: DashboardStats
  isLoading?: boolean
  isLoadingPaniers?: boolean
  acheteursEnPanier?: number
  openStatsModal: (type: string) => void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardStatsSection',
  props: {
    stats: {},
    isLoading: { type: Boolean, default: false },
    isLoadingPaniers: { type: Boolean, default: false },
    acheteursEnPanier: { default: 0 },
    openStatsModal: {}
  },
  emits: ["open-paniers"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()

const navigateToProductList = () => {
  router.push({ name: 'catalog/productlist' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(StatsCard), {
      title: "Chiffre d'affaires du mois",
      value: _ctx.stats.chiffreAffaires,
      suffix: "€",
      icon: "fas fa-euro-sign",
      "icon-color": "text-green-600",
      "icon-bg-color": "bg-green-100",
      change: _ctx.stats.chiffreAffairesChange,
      clickable: false,
      "is-loading": props.isLoading
    }, null, 8, ["value", "change", "is-loading"]),
    _createVNode(_unref(StatsCard), {
      title: "Commandes du mois",
      value: _ctx.stats.totalCommandes,
      icon: "fas fa-shopping-cart",
      "icon-color": "text-blue-600",
      "icon-bg-color": "bg-blue-100",
      change: _ctx.stats.commandesChange,
      "is-loading": props.isLoading,
      "action-label": "Voir les commandes",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openStatsModal('commandes'))),
      onAction: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openStatsModal('commandes')))
    }, null, 8, ["value", "change", "is-loading"]),
    _createVNode(_unref(StatsCard), {
      title: "Commandes en attente",
      value: _ctx.stats.commandesEnAttente,
      icon: "fas fa-clock",
      "icon-color": "text-yellow-600",
      "icon-bg-color": "bg-yellow-100",
      change: _ctx.stats.enAttenteChange,
      "is-loading": props.isLoading,
      "action-label": "Voir les commandes en attente",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openStatsModal('enAttente'))),
      onAction: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openStatsModal('enAttente')))
    }, null, 8, ["value", "change", "is-loading"]),
    _createVNode(_unref(StatsCard), {
      title: "Total des produits",
      value: _ctx.stats.totalProduits,
      icon: "fas fa-box",
      "icon-color": "text-purple-600",
      "icon-bg-color": "bg-purple-100",
      "is-loading": props.isLoading,
      "action-label": "Voir les produits",
      onClick: navigateToProductList,
      onAction: navigateToProductList
    }, null, 8, ["value", "is-loading"]),
    _createVNode(_unref(StatsCard), {
      title: "Acheteurs en panier",
      value: _ctx.acheteursEnPanier,
      icon: "fas fa-shopping-basket",
      "icon-color": "text-orange-600",
      "icon-bg-color": "bg-orange-100",
      "is-loading": _ctx.isLoadingPaniers,
      "action-label": "Voir le détail",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('open-paniers'))),
      onAction: _cache[5] || (_cache[5] = ($event: any) => (emit('open-paniers')))
    }, null, 8, ["value", "is-loading"])
  ]))
}
}

})